import React, { useEffect, useState } from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useLocation, useNavigate } from "react-router-dom";

import moment from "moment";
import StatusComp from "../../../components/StatusComp";
import { edit_icon, eye_icon, user, view_icon } from "../../../assets/imgs";
import { siteListDummy } from "../../redux/api/dummyJson";
import { get, post } from "../../../Services/ApiHandler";
import { URL as API } from "../../../Services/Constant";
import { toast } from "react-toastify";

const AdminAddCompany = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const type = location?.state?.type;
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
  const [logo, setLogo] = useState();
  const [ownerImg, setOwnerImg] = useState();
  const [companyID, setCompanyID] = useState(location?.state?.data?.id);
  const [email_verified, setEmail_verified] = useState(0);

  const createdAt = moment().format("DD-MM-YYYY");

  const comDataObj = {
    companyName: "",
    companyCode: "",
    person: "",
    email: "",
    mobile: "",
    password: "",
    confirmPassword: "",
    siteName: "",
    location: "",
  };

  const [comData, setComData] = useState(comDataObj);

  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);

  const [siteErrors, setSiteErrors] = useState({});
  const [emailCheckData, setEmailCheckData] = useState({});
  const [emailCheckFlag, setEmailCheckFlag] = useState(0);

  const [visible, setVisible] = useState(false);
  const [confVisible, setConfVisible] = useState(false);

  const [siteList, setSiteList] = useState([]);
  const [companyKnfRole, setCompanyKnfRole] = useState({});
  const [locList, setLoclist] = useState([]);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const getKfnRole = () => {
    post(API.KNF_ADMIN_ROLE)
      .then((res) => {
        if (res?.status == "success") {
          setCompanyKnfRole(res?.camera_role);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getSiteList = (company) => {
    let formdata = new FormData();
    formdata.append("company_id", company);
    post(API.SITE_LIST_ADMIN, formdata)
      .then((res) => {
        // setPagination(res?.pagination_meta);
        setSiteList(res?.lists);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getLocationList = () => {
    get(API.KNF_COMPANY_LOCATION)
      .then((res) => {
        if (res?.status == "success") {
          setLoclist(res?.data);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getView = () => {
    get(API.KNF_COMPANY_VIEW + location?.state?.data?.id)
      .then((res) => {
        let data = res?.data;
        if (data?.knf_user?.email_verified) {
          setEmail_verified(data?.knf_user?.email_verified);
        }
        if (data?.logo) {
          setLogo(data?.logo);
        }

        let ob = {
          companyName: "",
          companyCode: "",
          person: "",
          email: "",
          mobile: "",
          password: "",
          confirmPassword: "",
          siteName: "",
          location: "",
        };

        if (data?.company_name) {
          ob.companyName = data?.company_name;
        }

        if (data?.company_code) {
          ob.companyCode = data?.company_code;
        }

        if (data?.knf_user?.name) {
          ob.person = data?.knf_user?.name;
        }

        if (data?.knf_user?.email) {
          ob.email = data?.knf_user?.email;
        }
        if (data?.knf_user?.phone) {
          ob.mobile = data?.knf_user?.phone;
        }
        if (data?.location) {
          ob.location = data?.location;
        }

        setComData(ob);
        if (data?.knf_user?.profile_image) {
          setOwnerImg(data?.knf_user?.profile_image);
        }
        setEmailCheckFlag(1);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getKfnRole();
    getLocationList();

    if (location?.state?.data?.id) {
      getView();
      getSiteList(location?.state?.data?.id);
    }
  }, []);

  const validate = () => {
    const newErrors = {};
    const singaporeMobileRegex = /^[89]\d{7}$/;

    if (comData?.companyName?.length == 0)
      newErrors.companyName = "Company Name is required";
    if (comData?.companyCode?.length == 0)
      newErrors.companyCode = "Company Code is required";
    if (comData?.location?.length == 0)
      newErrors.location = "Location is required";
    if (comData?.email?.length == 0 || !emailRegex.test(comData?.email))
      newErrors.email = "Valid Email is required";
    // if (
    //   !comData?.mobile
    //   // || !singaporeMobileRegex.test(comData?.mobile)
    // ) {
    //   newErrors.mobile = "Enter valid 9-digit Singapore number";
    // }
    if (
      !comData?.mobile ||
      (comData?.mobile?.length !== 8 && comData?.mobile?.length !== 10)
    ) {
      newErrors.mobile = "Enter valid 8-digit or 10-digit mobile number";
    }
    if (comData?.person?.length == 0)
      newErrors.person = "Person Name is required";

    if (!companyID) {
      // if (comData?.password?.length == 0 || comData?.password.length < 6)
      //   newErrors.password = "Password must be at least 6 characters";
      // if (comData?.confirmPassword !== comData?.password)
      //   newErrors.confirmPassword = "Passwords do not match";

      if (!logo) newErrors.logo = "Company Logo is required";
      if (!ownerImg) newErrors.ownerImg = "Primary Person image is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // if (comData?.email?.length < 0) {
    //   setEmailCheckData({});
    // }
    setComData((prev) => ({ ...prev, [name]: value }));

    // clear specific error while typing
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setSiteErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSiteChange = (id, field, value) => {
    setSiteList((prev) =>
      prev.map((site) => (site.id === id ? { ...site, [field]: value } : site))
    );
    // clear site error
    setSiteErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSubmit = () => {
    if (validate()) {
      const formdata = new FormData();
      formdata.append("name", comData?.person);
      formdata.append("company_name", comData?.companyName);
      formdata.append("company_code", comData?.companyCode);
      formdata.append("email", comData?.email);
      formdata.append("knf_role_id", companyKnfRole?.id);
      formdata.append("phone", comData?.mobile);
      // if (comData?.password) {
      //   formdata.append("password", comData?.password);
      // }
      // if (comData?.password_confirmation) {
      //   formdata.append(
      //     "password_confirmation",
      //     comData?.password_confirmation
      //   );
      // }
      formdata.append("location", comData?.location);
      if (logo?.name) {
        formdata.append("logo", logo);
      }
      if (ownerImg?.name) {
        formdata.append("profile_image", ownerImg);
      }
      formdata.append("knf_type", 1);

      if (companyID) {
        // formdata.append("_method", "PATCH");
        post(API.COMPANY_EDIT + companyID, formdata)
          .then((res) => {
            if (res?.status == "success") {
              toast.success(res?.message);
              navigate("/admin-company-list");
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      } else {
        post(API.COMPANY_ADD, formdata)
          .then((res) => {
            if (res?.status == "success") {
              toast.success(res?.message);
              navigate("/admin-company-list");
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
      //   console.log("Submit successful", comData);
    }
  };

  const handleLogoChange = (event) => {
    let image = event.target.files[0];
    if (image) {
      setLogo(image);
      setErrors((prev) => ({
        ...prev,
        logo: "",
      }));
    }
  };
  // console.log('logo', logo)

  const handlePrimaryImg = (event) => {
    let image = event.target.files[0];
    if (image) {
      setOwnerImg(image);
      setErrors((prev) => ({
        ...prev,
        ownerImg: "",
      }));
    }
  };

  const autoFetchData = (data) => {
    setEmailCheckData(data);
    let ob = {
      companyName: "",
      companyCode: "",
      person: "",
      email: "",
      mobile: "",
      password: "",
      confirmPassword: "",
      siteName: "",
      location: "",
    };

    if (data?.company?.id) {
      setCompanyID(data?.company?.id);
    }

    if (data?.company?.logo) {
      setLogo(data?.company?.logo);
    }

    if (data?.company?.name) {
      ob.companyName = data?.company?.name;
    }

    if (data?.company?.company_code) {
      ob.companyCode = data?.company?.company_code;
    }

    if (data?.name) {
      ob.person = data?.name;
    }

    if (data?.email) {
      ob.email = data?.email;
    } else {
      ob.email = comData?.email;
    }

    if (data?.phone) {
      ob.mobile = data?.phone;
    }
    if (data?.company?.location) {
      ob.location = data?.company?.location;
    }

    setComData(ob);
    if (data?.profile_image) {
      setOwnerImg(data?.profile_image);
    }
  };

  const emailCheck = () => {
    let formdata = new FormData();
    if (comData?.email?.length > 0) {
      formdata.append("email", comData?.email);
      post(API.EMAIL_CHECK, formdata)
        .then((res) => {
          setEmailCheckFlag(1);
          if (res?.userData?.length > 0) {
            let data = res?.userData?.[0];
            if (data?.knf_type == 1) {
              autoFetchData(data);
            } else if (data?.knf_type == null) {
              autoFetchData(data);
            } else {
              toast.error("Email ID already exists");
            }
          } else {
            let ob = {
              ...comDataObj,
              email: comData.email,
            };
            setComData(ob);
            setEmailCheckData({});
            toast("please enter all required fields");
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      toast.error("Please Enter Valid Email");
    }
  };

  console.log("email_verified", email_verified);

  return (
    <div className="dashRightView">
      <StatusComp name={"Company"} type={type} />

      <div className="d-flex flex-wrap gap-5">
        <div className="col-md-5">
          <div className="d-flex w-100 ac-jb">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Primary Email id<span className="text-danger">*</span>
            </p>
            {type == "edit" && (
              <p className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-12 mb-1 text-primary mx-2">
                {email_verified
                  ? "Email Verified"
                  : "Email Verification pending"}
              </p>
            )}
          </div>
          <div className="d-flex">
            <input
              className="input-box"
              name="email"
              value={comData?.email}
              onChange={(even) => {
                // handleChange(even)
                setComData(() => ({ ...comDataObj, email: even.target.value }));
                setEmailCheckFlag(0);
              }}
              type="email"
              placeholder="Primary Email id"
              // disabled={type == "edit" ? true : false}
            />
            {/* {email_verified == 0 && ( */}
            {/* {comData?.email?.length > 1 && ( */}
            <button
              className={`email_check_btn ${
                !emailRegex?.test(comData?.email) ? "opacity-50" : ""
              }`}
              disabled={
                comData?.email?.length == 0
                  ? true
                  : // : type == "edit"
                    // ? true
                    false
              }
              onClick={() => emailCheck()}
            >
              Check
            </button>
            {/* )} */}
          </div>
          {errors.email && <p className="err">{errors.email}</p>}
        </div>
        {emailCheckFlag == 1 && (
          <>
            <div className="col-md-5">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
                Company name<span className="text-danger">*</span>
              </p>
              <input
                className="input-box"
                name="companyName"
                value={comData?.companyName}
                onChange={handleChange}
                type="text"
                placeholder="Company name"
                disabled={
                  emailCheckData?.company?.name
                    ? true
                    : emailCheckFlag == 0
                    ? true
                    : false
                }
              />
              {errors?.companyName && (
                <p className="err">{errors?.companyName}</p>
              )}
            </div>
            <div className="col-md-5">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
                Company Code<span className="text-danger">*</span>
              </p>
              <input
                className="input-box"
                name="companyCode"
                value={comData?.companyCode}
                onChange={handleChange}
                type="text"
                placeholder="Company Code"
                disabled={
                  emailCheckData?.company?.company_code
                    ? true
                    : emailCheckFlag == 0
                    ? true
                    : false
                }
              />
              {errors?.companyCode && (
                <p className="err">{errors.companyCode}</p>
              )}
            </div>
            {type == "add" && (
              <div className="col-md-5">
                <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
                  Company Logo (size 2 MB)<span className="text-danger">*</span>
                </p>
                <input
                  className="input-box"
                  name="logo"
                  onChange={handleLogoChange}
                  type="file"
                  placeholder="Company Logo"
                  accept="image/*"
                  disabled={
                    emailCheckData?.company?.logo
                      ? true
                      : emailCheckFlag == 0
                      ? true
                      : false
                  }
                />
                {errors.logo && <p className="err">{errors.logo}</p>}
              </div>
            )}

            {type != "add" && (
              <div className="col-md-5">
                <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                  Company logo
                </p>
                {logo ? (
                  <img
                    src={logo?.name ? URL.createObjectURL(logo) : logo}
                    alt=""
                    className="user"
                  />
                ) : (
                  <img src={user} alt="" className="user" />
                )}
                {type != "view" && (
                  <>
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      id="edit-logo"
                      onChange={handleLogoChange}
                      disabled={
                        emailCheckData?.company?.logo
                          ? true
                          : emailCheckFlag == 0
                          ? true
                          : false
                      }
                    />

                    <button
                      onClick={() =>
                        document.getElementById("edit-logo").click()
                      }
                      className="cust-btn"
                    >
                      <img src={edit_icon} alt="" className="ms-4 edit-btn" />
                    </button>
                  </>
                )}
              </div>
            )}
            <div className="col-md-5">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
                Primary person<span className="text-danger">*</span>
              </p>
              <input
                className="input-box"
                name="person"
                value={comData?.person}
                onChange={handleChange}
                type="text"
                placeholder="Primary person"
                disabled={
                  emailCheckData?.name
                    ? true
                    : emailCheckFlag == 0
                    ? true
                    : false
                }
              />
              {errors.person && <p className="err">{errors.person}</p>}
            </div>
            {type == "add" && (
              <div className="col-md-5">
                <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
                  Primary person image (size 2 MB)
                  <span className="text-danger">*</span>
                </p>
                <input
                  className="input-box"
                  name="logo"
                  onChange={handlePrimaryImg}
                  type="file"
                  placeholder="Company Logo"
                  accept="image/*"
                  disabled={emailCheckFlag == 0 ? true : false}
                />
                {errors.ownerImg && <p className="err">{errors.ownerImg}</p>}
              </div>
            )}

            {type != "add" && (
              <div className="col-md-5">
                <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                  Primary person image
                </p>

                <img
                  src={
                    ownerImg
                      ? ownerImg?.name
                        ? URL.createObjectURL(ownerImg)
                        : ownerImg
                      : user
                  }
                  alt=""
                  className="user"
                />
                {type !== "view" && (
                  <>
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      id="edit-logo1"
                      onChange={handlePrimaryImg}
                    />

                    <button
                      onClick={() =>
                        document.getElementById("edit-logo1").click()
                      }
                      className="cust-btn"
                    >
                      <img src={edit_icon} alt="" className="ms-4 edit-btn" />
                    </button>
                  </>
                )}
              </div>
            )}

            <div className="col-md-5">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary flex">
                Primary Singapore Mobile number
                <span className="text-danger">*</span>
              </p>
              <input
                name="mobile"
                value={comData?.mobile}
                maxLength={8}
                onChange={handleChange}
                className="input-box"
                type="text"
                placeholder="+65 Mobile number"
                disabled={
                  emailCheckData?.phone
                    ? true
                    : emailCheckFlag == 0
                    ? true
                    : false
                }
              />
              {errors.mobile && <p className="err">{errors.mobile}</p>}
            </div>

            <div className="col-md-5">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary flex">
                Location<span className="text-danger">*</span>
              </p>
              <select
                name="location"
                value={comData?.location}
                onChange={handleChange}
                className="input-box"
                type="text"
                disabled={
                  emailCheckData?.company?.location
                    ? true
                    : emailCheckFlag == 0
                    ? true
                    : false
                }
              >
                <option>Select Location</option>
                {locList?.map((item) => {
                  return (
                    <option value={item?.id} key={item?.id}>
                      {item?.name}
                    </option>
                  );
                })}
              </select>
              {errors.location && <p className="err">{errors.location}</p>}
            </div>
          </>
        )}
        {/* {type !== "view" && (
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Password
              {type !== "view" || type !== "edit" ? (
                <span className="text-danger">*</span>
              ) : (
                ""
              )}
            </p>
            <div className="input-box ac-jb ">
              <LockOutlinedIcon className="emial-icon" />
              <input
                name="password"
                value={comData?.password}
                onChange={handleChange}
                type={visible ? "text" : "password"}
                maxLength={20}
                placeholder="Password"
                disabled={emailCheckData?.company_id ?? false}
              />
              {!visible && (
                <img
                  src={eye_icon}
                  onClick={() => setVisible(!visible)}
                  className="eye-icon pointer mb-1"
                  alt=""
                />
              )}
              {visible && (
                <VisibilityIcon
                  onClick={() => setVisible(!visible)}
                  className="eye-icon "
                />
              )}
            </div>
            {errors.password && <p className="err">{errors.password}</p>}
          </div>
        )} */}
        {/* {type !== "view" && (
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Confirm Password{" "}
              {type !== "view" || type !== "edit" ? (
                <span className="text-danger">*</span>
              ) : (
                ""
              )}
            </p>
            <div className="input-box ac-jb">
              <LockOutlinedIcon className="emial-icon" />
              <input
                name="confirmPassword"
                value={comData?.confirmPassword}
                onChange={handleChange}
                type={confVisible ? "text" : "password"}
                maxLength={20}
                placeholder="Confirm Password"
                disabled={emailCheckData?.company_id ?? false}
              />
              {!confVisible && (
                <img
                  src={eye_icon}
                  onClick={() => setConfVisible(!confVisible)}
                  className="eye-icon pointer mb-1"
                  alt=""
                />
              )}
              {confVisible && (
                <VisibilityIcon
                  onClick={() => setConfVisible(!confVisible)}
                  className="eye-icon "
                />
              )}
            </div>
            {errors.confirmPassword && (
              <p className="err">{errors.confirmPassword}</p>
            )}
          </div>
        )} */}
      </div>
      <div className="d-flex ac-jb mt-5">
        <button
          onClick={() => navigate(-1)}
          className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
        >
          Back
        </button>

        {(givenpermissions?.includes("CAN-Add-KNF_ADMIN_COMPANY") ||
          givenpermissions?.includes("CAN-Edit-KNF_ADMIN_COMPANY")) &&
          type != "view" && (
            <>
              {emailCheckData?.id ? (
                <button
                  onClick={handleSubmit}
                  className={` submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 ${
                    emailCheckData?.email == comData?.email ? "" : "opacity-50"
                  }`}
                  disabled={
                    emailCheckData?.email == comData?.email ? false : true
                  }
                >
                  {type == "edit" ? "Submit" : "Add"}
                </button>
              ) : (
                <button
                  onClick={handleSubmit}
                  className={`submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 ${
                    emailCheckFlag == 1 ? "" : "opacity-50"
                  }`}
                  disabled={emailCheckFlag == 1 ? false : true}
                >
                  {type == "edit" ? "Submit" : "Add"}
                </button>
              )}
            </>
          )}
      </div>

      {type == "view" && !show && (
        // <button onClick={() => setShow(true)} className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "  >
        //     Add Site
        // </button>
        <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17  mt-4 primary">
          Site List
        </p>
      )}

      {show && (
        <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mt-4 primary">
          Site List
        </p>
      )}

      {givenpermissions?.includes("CAN-List-KNF_ADMIN_SITE") &&
        type !== "add" && (
          <div className="container mt-4">
            <table className="table table-bordered align-middle">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>Site Name & Code</th>
                  <th>Site Location</th>
                  <th>Site Admin</th>
                  <th>Created On</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {siteList?.map((item, ind) => (
                  <tr key={ind} className="text-center">
                    <td>{ind + 1}</td>
                    <td>
                      <div>{item?.site_name}</div>
                      <div className="text-muted">{item?.site_code}</div>
                    </td>
                    <td>{item?.site_location}</td>
                    <td>
                      {/* <div>kbf admin</div> */}
                      <div className="text-muted">{item?.user_email}</div>
                      <div className="text-muted">{item?.user_phone}</div>
                    </td>
                    <td>
                      <div className="text-muted">
                        {item?.created_at
                          ? moment(item?.created_at).format("DD-MM-YYYY")
                          : ""}
                      </div>
                    </td>
                    <td className="d-flex ac-jc gap-4">
                      <button
                        onClick={() => {
                          navigate("/sites-view", {
                            state: { type: "view", data: item },
                          });
                        }}
                        className="cust-btn "
                      >
                        <img src={view_icon} alt="" className=" edit-btn " />
                      </button>

                      <button
                        className={`${
                          item?.status ? "active-btn" : "deactive-btn"
                        } w-100 border-0 opacity-50`}
                      >
                        {item?.status ? "Active" : "De-active"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
    </div>
  );
};

export default AdminAddCompany;
